import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { Link } from 'react-router-dom';
import { SortDescriptor } from '@progress/kendo-data-query';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { fetchApi } from 'services/api';

export type UpcomingOrder = {
  OrderID: number;
  OrderNumber: number;
  TotalCharges: number;
  PastShipDateTime: boolean;
  ShipDateTime: string;
  Distance: number;
  TotalDistance: number;
  BillingCustomerID: number;
  BillingCustomerNumber: string;
  Origin: string;
  Destination: string;
  Pieces: number;
  Weight: number;
}

type Props = {
  Coordinates: { Latitude: number; Longitude: number; };
  Orders: UpcomingOrder[];
  Close: () => void;
};

const UpcomingOrdersDialog = (props: Props) => {
  const [unitsInArea, setUnitsInArea] = useState<Array<{ VehicleTypeName: string; Count: number }>>([]);
  const [sort, setSort] = useState<SortDescriptor[]>([{ field: 'Distance', dir: 'asc' }]);

  useEffect(() => {
    fetchApi('/api/Quote/VirtualTerminalUnitsInArea', props.Coordinates, 'POST')
      .then((data) => {
        setUnitsInArea(data.UnitsInArea);
      });
  }, [props.Coordinates]);

  return (
    <Dialog title="Upcoming Orders" onClose={props.Close} className="dialog-w11/12">
      {unitsInArea.length > 0 && <div className="alert alert-info m-0">
        <strong>Units In Area:</strong> There are currently
          <span>
            {' '}
            {unitsInArea.map(
              (unit) => `${unit.Count} ${unit.VehicleTypeName}${unit.Count > 1 ? 'S' : ''}`
            ).join(', ')}
          </span> within 150 miles of this location.
      </div>}
      <Grid
        autoProcessData
        sortable
        sort={sort}
        onSortChange={(e) => setSort(e.sort)}
        data={props.Orders}
        className="mt-2"
        scrollable='none'
      >
        <Column field="OrderNumber" title="Order #" cells={{ data: (props) => <td {...props.tdProps}>
          <Link target='_blank' style={{ color: "#007bff" }} to={`/Order/${props.dataItem.OrderID}`}>{props.dataItem.OrderNumber}</Link>
        </td>}} />
        <Column field="BillingCustomerNumber" title="Bill To" cells={{ data: (props) => <td {...props.tdProps}>
          <Link target='_blank' style={{ color: "#007bff" }} to={`/Customers/Customer/${props.dataItem.BillingCustomerID}`}>{props.dataItem.BillingCustomerNumber}</Link>
        </td>}} />
        <Column field="ShipDateTime" title="Ship Date" width={180} cells={{ data: (props) => <td {...props.tdProps} className={[props.tdProps?.className, props.dataItem.PastShipDateTime ? 'text-danger' : undefined].filter(Boolean).join(" ")}>
          {dayjs.utc(props.dataItem.ShipDateTime).tz("America/New_York").format("MM/DD/YYYY HH:mm")}
        </td>}} />
        <Column field="Distance" title="DH to PU" format="{0:n0} mi" />
        <Column field="TotalDistance" title="Loaded" format="{0:n0} mi" />
        <Column field="Origin" title="Origin" />
        <Column field="Destination" title="Destination" />
        <Column field="Pieces" format="{0:n0}" />
        <Column field="Weight" format="{0:n0} lbs" />
        <Column field="TotalCharges" title="Charges" format="{0:c2}" />
      </Grid>
      <DialogActionsBar>
        <Button onClick={props.Close}>Close</Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default UpcomingOrdersDialog;
